const action = 'WORKSPACE_ELIGIBLE_MEMBERS';
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { organizationId } (falsy organizationId = resolve the viewer's
// first Team+ org via /organization/mine)
export const fetchRequest = (payload) => ({
  type: REQUEST,
  payload,
});

// payload: { members: [...] | null } — null means "no rights / no org"
export const fetchSuccess = (payload) => ({
  type: RESPONSE,
  payload,
});

export const fetchFailure = (payload) => ({
  type: FAILURE,
  payload,
});

export const clear = () => ({
  type: CLEAR,
});
